export default __webpack_public_path__ + "static/media/icon_etherscan.10a5b421.png";